import { REQUEST_TYPE, type RequestType } from '@hotel-voice/shared';
import type { GetGuestServicesResponse } from '@hotel-voice/shared';

/**
 * The restaurant menu and the hotel store are the same ordering flow with
 * different words: browse by category, build a cart, review, place. This
 * config is everything that differs, so `RestaurantPage` renders both.
 */
export interface OrderCatalog {
  type: RequestType;
  flag: keyof GetGuestServicesResponse['flags'];
  pick: (services: GetGuestServicesResponse) => GetGuestServicesResponse['menu'];
  title: string;
  subtitle: string;
  serviceName: string;
  loadError: string;
  emptyTitle: string;
  noteLabel: string;
  notePlaceholder: string;
  /** Sentence after a successful order; the room number is appended. */
  placed: (total: string) => string;
  successTitle: string;
  again: string;
  /** Dishes carry a veg/non-veg mark and a preparation time; products do not. */
  dishFields: boolean;
}

export const RESTAURANT_CATALOG: OrderCatalog = {
  type: REQUEST_TYPE.RESTAURANT,
  flag: 'restaurantService',
  pick: (services) => services.menu,
  title: 'Restaurant',
  subtitle: 'Order to your room',
  serviceName: 'Restaurant service',
  loadError: 'Could not load the menu.',
  emptyTitle: 'The menu is empty',
  noteLabel: 'Comments for the chef',
  notePlaceholder: 'e.g. Less spicy, please.',
  placed: (total) => `Your order of ${total} is with the kitchen. We’ll bring it to`,
  successTitle: 'Order placed',
  again: 'Order something else',
  dishFields: true,
};

export const STORE_CATALOG: OrderCatalog = {
  type: REQUEST_TYPE.STORE,
  flag: 'storeService',
  pick: (services) => services.store,
  title: 'Hotel Store',
  subtitle: 'Toiletries, souvenirs & more',
  serviceName: 'Hotel store',
  loadError: 'Could not load the store.',
  emptyTitle: 'The store is empty',
  noteLabel: 'Note for the store',
  notePlaceholder: 'e.g. Please deliver after 6 pm.',
  placed: (total) => `Your order of ${total} is on its way. We’ll bring it to`,
  successTitle: 'Order placed',
  again: 'Buy something else',
  dishFields: false,
};
